import React from 'react';
import MobileNavigation from './MobileNavigation';
import Navbar from './Navbar';
import Footer from './Footer';
import Status from './Status';
import { Helmet } from 'react-helmet';

function OnboardingStatus() {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <main>
        <MobileNavigation />

        <Status navbar={<Navbar />} />

        <Footer />
      </main>
    </>
  );
}

export default OnboardingStatus;
